import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DropdownPopper from '../Dropdown/DropdownPopper';
/**
 * A [`DropdownPopper`](#/Dialog%20components?id=dropdownpopper) used specifically for
 * [`Menu`](#/Dialog%20components?id=menu) components.
 *
 * @since 7.28.0
 */
// For some reason, extending Toast directly breaks in IE11
// https://github.com/styled-components/styled-components/issues/2190#issuecomment-461488882

var MenuPopper = /*#__PURE__*/styled(function (props) {
  return /*#__PURE__*/React.createElement(DropdownPopper, props);
}).withConfig({
  displayName: "MenuPopper",
  componentId: "c11n-8-64-0__sc-1uu201g-0"
})([""]);
MenuPopper.propTypes = {
  /**
   * https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
   */
  'aria-haspopup': PropTypes.oneOf(['menu']),

  /**
   * The [`Trigger`](#/Dialog%20components?id=trigger) `generateLabelledBy` prop.
   */
  'generateLabelledBy': PropTypes.bool
};
MenuPopper.defaultProps = {
  'aria-haspopup': 'menu',
  'generateLabelledBy': true
};
/** @component */

export default MenuPopper;
export var StyledMenuPopper = MenuPopper;